export default __webpack_public_path__ + "static/media/Zurich.1bd386f0.ttf";